import { render, staticRenderFns } from "./swiftcache.vue?vue&type=template&id=2a2d3b57"
import script from "./swiftcache.vue?vue&type=script&lang=js"
export * from "./swiftcache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports